export default "__VITE_ASSET__5Y2VeMSv__"